import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.promise.finally.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { RawContextKey, IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
import { KeybindingsRegistry } from '../../../platform/keybinding/common/keybindingsRegistry.js';
import { registerEditorCommand, EditorCommand } from '../../browser/editorExtensions.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { Range } from '../../common/core/range.js';
import { dispose as _dispose, combinedDisposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { Emitter } from '../../../base/common/event.js';
import { localize } from '../../../nls.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { isEqual } from '../../../base/common/resources.js';
export var ctxHasSymbols = new RawContextKey('hasSymbols', false);
export var ISymbolNavigationService = createDecorator('ISymbolNavigationService');

var SymbolNavigationService = /*#__PURE__*/function () {
  function SymbolNavigationService(contextKeyService, _editorService, _notificationService, _keybindingService) {
    _classCallCheck(this, SymbolNavigationService);

    this._editorService = _editorService;
    this._notificationService = _notificationService;
    this._keybindingService = _keybindingService;
    this._currentModel = undefined;
    this._currentIdx = -1;
    this._ignoreEditorChange = false;
    this._ctxHasSymbols = ctxHasSymbols.bindTo(contextKeyService);
  }

  _createClass(SymbolNavigationService, [{
    key: "reset",
    value: function reset() {
      this._ctxHasSymbols.reset();

      _dispose(this._currentState);

      _dispose(this._currentMessage);

      this._currentModel = undefined;
      this._currentIdx = -1;
    }
  }, {
    key: "put",
    value: function put(anchor) {
      var _this = this;

      var refModel = anchor.parent.parent;

      if (refModel.references.length <= 1) {
        this.reset();
        return;
      }

      this._currentModel = refModel;
      this._currentIdx = refModel.references.indexOf(anchor);

      this._ctxHasSymbols.set(true);

      this._showMessage();

      var editorState = new EditorState(this._editorService);
      var listener = editorState.onDidChange(function (_) {
        if (_this._ignoreEditorChange) {
          return;
        }

        var editor = _this._editorService.getActiveCodeEditor();

        if (!editor) {
          return;
        }

        var model = editor.getModel();
        var position = editor.getPosition();

        if (!model || !position) {
          return;
        }

        var seenUri = false;
        var seenPosition = false;

        var _iterator = _createForOfIteratorHelper(refModel.references),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var reference = _step.value;

            if (isEqual(reference.uri, model.uri)) {
              seenUri = true;
              seenPosition = seenPosition || Range.containsPosition(reference.range, position);
            } else if (seenUri) {
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!seenUri || !seenPosition) {
          _this.reset();
        }
      });
      this._currentState = combinedDisposable(editorState, listener);
    }
  }, {
    key: "revealNext",
    value: function revealNext(source) {
      var _this2 = this;

      if (!this._currentModel) {
        return Promise.resolve();
      } // get next result and advance


      this._currentIdx += 1;
      this._currentIdx %= this._currentModel.references.length;
      var reference = this._currentModel.references[this._currentIdx]; // status

      this._showMessage(); // open editor, ignore events while that happens


      this._ignoreEditorChange = true;
      return this._editorService.openCodeEditor({
        resource: reference.uri,
        options: {
          selection: Range.collapseToStart(reference.range),
          selectionRevealType: 3
          /* NearTopIfOutsideViewport */

        }
      }, source).finally(function () {
        _this2._ignoreEditorChange = false;
      });
    }
  }, {
    key: "_showMessage",
    value: function _showMessage() {
      _dispose(this._currentMessage);

      var kb = this._keybindingService.lookupKeybinding('editor.gotoNextSymbolFromResult');

      var message = kb ? localize('location.kb', "Symbol {0} of {1}, {2} for next", this._currentIdx + 1, this._currentModel.references.length, kb.getLabel()) : localize('location', "Symbol {0} of {1}", this._currentIdx + 1, this._currentModel.references.length);
      this._currentMessage = this._notificationService.status(message);
    }
  }]);

  return SymbolNavigationService;
}();

SymbolNavigationService = __decorate([__param(0, IContextKeyService), __param(1, ICodeEditorService), __param(2, INotificationService), __param(3, IKeybindingService)], SymbolNavigationService);
registerSingleton(ISymbolNavigationService, SymbolNavigationService, true);
registerEditorCommand(new ( /*#__PURE__*/function (_EditorCommand) {
  _inherits(_class, _EditorCommand);

  var _super = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super.call(this, {
      id: 'editor.gotoNextSymbolFromResult',
      precondition: ctxHasSymbols,
      kbOpts: {
        weight: 100
        /* EditorContrib */
        ,
        primary: 70
        /* F12 */

      }
    });
  }

  _createClass(_class, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor) {
      return accessor.get(ISymbolNavigationService).revealNext(editor);
    }
  }]);

  return _class;
}(EditorCommand))());
KeybindingsRegistry.registerCommandAndKeybindingRule({
  id: 'editor.gotoNextSymbolFromResult.cancel',
  weight: 100
  /* EditorContrib */
  ,
  when: ctxHasSymbols,
  primary: 9
  /* Escape */
  ,
  handler: function handler(accessor) {
    accessor.get(ISymbolNavigationService).reset();
  }
}); //

var EditorState = /*#__PURE__*/function () {
  function EditorState(editorService) {
    _classCallCheck(this, EditorState);

    this._listener = new Map();
    this._disposables = new DisposableStore();
    this._onDidChange = new Emitter();
    this.onDidChange = this._onDidChange.event;

    this._disposables.add(editorService.onCodeEditorRemove(this._onDidRemoveEditor, this));

    this._disposables.add(editorService.onCodeEditorAdd(this._onDidAddEditor, this));

    editorService.listCodeEditors().forEach(this._onDidAddEditor, this);
  }

  _createClass(EditorState, [{
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();

      this._onDidChange.dispose();

      _dispose(this._listener.values());
    }
  }, {
    key: "_onDidAddEditor",
    value: function _onDidAddEditor(editor) {
      var _this3 = this;

      this._listener.set(editor, combinedDisposable(editor.onDidChangeCursorPosition(function (_) {
        return _this3._onDidChange.fire({
          editor: editor
        });
      }), editor.onDidChangeModelContent(function (_) {
        return _this3._onDidChange.fire({
          editor: editor
        });
      })));
    }
  }, {
    key: "_onDidRemoveEditor",
    value: function _onDidRemoveEditor(editor) {
      _dispose(this._listener.get(editor));

      this._listener.delete(editor);
    }
  }]);

  return EditorState;
}();

EditorState = __decorate([__param(0, ICodeEditorService)], EditorState);